import * as constants from '../constants';

const setHubList = (data) => {
    if (data && data.response) {
        const { totalCount, ...payload } = data.response;
        return { type: constants.SET_HUB_LIST, payload };
    }
};

export const fetchAgencyHubList = (onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/hubs/list/all',
        method: 'GET',
        success: setHubList,
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        hideNotify: true,
    },
});

export const fetchAgencyDashboardCounts = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/agency/dashboard/counts',
        method: 'POST',
        data,
        success: (response) => ({
            type: constants.DO_NOTHING,
            payload: response.response,
        }),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    },
});

export const fetchAgencyLeadList = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/agency/lead/list',
        method: 'POST',
        data,
        success: (response) => ({
            type: constants.DO_NOTHING,
            payload: response.response,
        }),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    },
});

export const uploadAgencySingleLead = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/agency/lead/single',
        method: 'POST',
        data,
        success: (response) => ({
            type: constants.DO_NOTHING,
            payload: response.response,
        }),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    },
});

export const uploadAgencyBulkLeads = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/agency/lead/bulk',
        method: 'POST',
        data,
        success: (response) => ({
            type: constants.DO_NOTHING,
            payload: response.response,
        }),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    },
});

export const fetchAgencyBulkUploadList = (data, onSuccess, onError) => {
    const query = Object.entries(data ?? {})
        .filter(([, v]) => v !== null && v !== undefined && v !== '')
        .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
        .join('&');

    return {
        type: constants.API,
        payload: {
            url: `/agency/lead/bulk/uploads${query ? `?${query}` : ''}`,
            method: 'GET',
            success: (response) => ({
                type: constants.DO_NOTHING,
                payload: response.response,
            }),
            postProcessSuccess: onSuccess,
            postProcessError: onError,
            hideNotify: true,
        },
    };
};

export const fetchReferralPoolList = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/agency/referral/pool/list',
        method: 'POST',
        data,
        success: (response) => ({
            type: constants.DO_NOTHING,
            payload: response.response,
        }),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    },
});

// type: 'zones' | 'stores'; cityId narrows the list, omit for all. Cities come from GetCities (/common/cities/all)
export const fetchAgencyLookup = (type, cityId, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/agency/lookup/${type}${cityId ? `?cityId=${cityId}` : ''}`,
        method: 'GET',
        success: (response) => ({
            type: constants.DO_NOTHING,
            payload: response.response,
        }),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        hideNotify: true,
    },
});

const agencyGet = (url, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url,
        method: 'GET',
        success: (response) => ({
            type: constants.DO_NOTHING,
            payload: response.response,
        }),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    },
});

export const fetchAgencyUploadChunks = (uploadId, onSuccess, onError) =>
    agencyGet(`/agency/lead/bulk/uploads/${uploadId}/chunks`, onSuccess, onError);

// Goes through the API (not a stored URL) so each chunk download is logged server-side
export const fetchAgencyChunkResult = (uploadId, chunkNo, onSuccess, onError) =>
    agencyGet(`/agency/lead/bulk/uploads/${uploadId}/chunks/${chunkNo}/result`, onSuccess, onError);

export const fetchAgencyDailyLimit = (onSuccess, onError) => {
    const action = agencyGet('/agency/lead/daily-limit', onSuccess, onError);
    return { ...action, payload: { ...action.payload, hideNotify: true } };
};
